module.exports = __webpack_public_path__ + "img/code-review.65709b61.jpg";